<template>
  <v-footer class="red" dark padless app inset absolute>
    <v-card class="flex" flat tile>
      <v-card-text class="py-2 white--text text-center">
        ©{{ new Date().getFullYear() }} —
        <small>บริษัท เคเอ็มพี พาร์ทเนอร์ จำกัด ที่อยู่ AH2 ตำบล ขันเงิน อำเภอหลังสวน ชุมพร 86110 โทร. 096 636 3144</small>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    icons: [
      "fab fa-facebook",
      "fab fa-twitter",
      "fab fa-google-plus",
      "fab fa-linkedin",
      "fab fa-instagram"
    ]
  })
};
</script>
<style>
.red{
  background-color: #dd0000 !important;
}
</style>